export default __webpack_public_path__ + "static/media/avatar.eb24166d.png";